import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Handles the OAuth return: reads session_id from the URL fragment,
// exchanges it via the backend, then redirects into the app.
export default function AuthCallback() {
  const { processSessionId } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate('/login', { replace: true });
        return;
      }
      try {
        const u = await processSessionId(sessionId);
        // clear the hash and route to destination
        window.history.replaceState(null, '', window.location.pathname);
        navigate(u && ['committee', 'admin'].includes(u.memberClass) ? '/admin/ops' : '/', { replace: true });
      } catch (e) {
        navigate('/login', { replace: true, state: { error: 'Sign-in failed. Please try again.' } });
      }
    };
    run();
  }, [processSessionId, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--sage)' }}>
      <div className="text-center">
        <div
          className="mx-auto mb-4 w-10 h-10 rounded-full animate-spin"
          style={{ border: '4px solid rgba(0,0,0,0.15)', borderTopColor: 'var(--maroon)' }}
        />
        <p className="font-title" style={{ color: 'var(--navy)' }}>Signing you in…</p>
      </div>
    </div>
  );
}
